import { render, staticRenderFns } from "./BellDuplicate.vue?vue&type=template&id=5330655e&scoped=true"
import script from "./BellDuplicate.vue?vue&type=script&lang=js"
export * from "./BellDuplicate.vue?vue&type=script&lang=js"
import style0 from "./BellDuplicate.vue?vue&type=style&index=0&id=5330655e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5330655e",
  null
  
)

export default component.exports